/**
 * userAgent.js
 * Detects if the app is running inside a restrictive In-App Browser (Kakao, Naver, Instagram, etc).
 */
export const isInAppBrowser = () => {
    const ua = navigator.userAgent || navigator.vendor || window.opera;
    // Regex covers: KakaoTalk (KAKAOTALK), Instagram, Naver, FB (FBAV/FBAN), Line
    // Added: KAKAOTALK explicitly for strict matching if needed, though 'i' flag covers it.
    // Also checking for 'Daum' just in case.
    return /KakaoTalk|KAKAOTALK|Instagram|NAVER|FBAV|FBAN|Line|DaumApps/i.test(ua);
};
